import type {ReactElement} from 'react';
import {BottomBarItem} from '@Components/contextual-menu/components/bottom-bar-item/bottom-bar-item';
import {useIconButtonAction} from '@EmailMakerReact/layout/email-maker-right-panel/controls/icon-button-control/icon-button-control';
import type {IconButtonControlDescriptor} from '@EmailMakerReact/layout/email-maker-right-panel/controls/icon-button-control/icon-button-control.types';
import type {EmailMakerControlProps} from '@EmailMakerReact/layout/email-maker-right-panel/right-panel-registry.types';
import styles from './action-strip.module.scss';

interface MobileIconButtonActionProps {
  component: EmailMakerControlProps['component'];
  descriptor: IconButtonControlDescriptor;
}

/**
 * Mobile strip rendering for an instant/toggle icon-button action (Duplicate / Lock / Delete / Save /
 * Clear). Reuses the shared `useIconButtonAction` hook so the toggle / save / delete / click logic is
 * not duplicated, and renders a `<BottomBarItem>` so the action matches the style tiles and the
 * sheet-opening actions in the same row. Delete keeps the desktop control's red icon colour.
 */
export function MobileIconButtonAction({component, descriptor}: MobileIconButtonActionProps): ReactElement {
  const {iconClass, captionText, handleClick, isDeleteButton} = useIconButtonAction(component, descriptor);

  return (
    <BottomBarItem
      id={`email-maker-action-${descriptor.action}`}
      icon={iconClass}
      text={captionText}
      textClasses={styles.label}
      iconClasses={isDeleteButton ? styles.deleteIcon : ''}
      onClick={handleClick}
    />
  );
}
